import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliatesUnconfirmedListItem } from '../types';
import {
  AFFILIATES_UNCONFIRMED_LIST_QUERY_KEY,
  AFFILIATES_UNCONFIRMED_LIST_URL,
  AFFILIATES_UNCONFIRMED_PERMISSIONS,
} from '../constants';

export default function useAffiliatesUnconfirmedListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAffiliatesUnconfirmedListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliatesUnconfirmedListItem>>({
    queryKey: [AFFILIATES_UNCONFIRMED_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliatesUnconfirmedListItem>>(
      AFFILIATES_UNCONFIRMED_LIST_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATES_UNCONFIRMED_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
